import { jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';
import { CommonWrapper } from './CommonWrapper.js';

function BreadcrumbsText({ children, "data-testid": dataTestId, isActive = false, sxWrapper, sxText, onClick, }) {
    return (jsx(CommonWrapper, { sx: sxWrapper, children: jsx(Text, { "$isActive": isActive, "data-testid": dataTestId, sx: sxText, onClick: onClick, children: jsx(Typography, { fontSize: 12, fontWeight: 500, sx: { paddingLeft: 0, textTransform: "uppercase" }, children: children }) }) }));
}
const Text = styled("span")(({ theme, $isActive }) => (Object.assign({ borderRadius: 4, color: theme.palette.text.primary, fontFamily: theme.typography.fontFamily, fontSize: theme.typography.fontSize, fontWeight: theme.typography.fontWeightMedium, letterSpacing: 1, padding: theme.spacing(0.5), textDecoration: "none", textTransform: "uppercase", display: "flex", justifyContent: "center", alignItems: "center", cursor: "default" }, ($isActive && {
    color: theme.palette.primary.main,
}))));

export { BreadcrumbsText, Text };
//# sourceMappingURL=BreadcrumbsText.js.map
